var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubspotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_2",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F47622;}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M21.6,11.4c-0.5-0.9-1.3-1.6-2.2-2.2c-0.7-0.4-1.4-0.7-2.2-0.8V5.6c0.8-0.3,1.3-1.1,1.3-2  c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2c0,0.9,0.5,1.6,1.3,2v2.9c-0.7,0.1-1.3,0.3-2,0.6C12.2,8.1,8,5,5.6,3.2  C5.6,3,5.7,2.8,5.7,2.6c0-1.3-1.1-2.4-2.5-2.4S0.8,1.2,0.8,2.6C0.8,3.9,1.9,5,3.2,5c0.5,0,0.9-0.1,1.3-0.4L5,5l7,5  c-0.4,0.3-0.7,0.7-1,1.2c-0.6,0.9-0.9,1.8-0.9,2.9v0.2c0,0.7,0.1,1.4,0.4,2.1c0.2,0.6,0.5,1.1,0.9,1.6l-2.3,2.3  c-0.7-0.3-1.5-0.1-2,0.4C6.7,21,6.5,21.5,6.5,22c0,0.5,0.2,1,0.6,1.3c0.4,0.4,0.8,0.5,1.3,0.5c0.5,0,1-0.2,1.3-0.5  c0.4-0.3,0.6-0.8,0.6-1.3c0-0.2,0-0.4-0.1-0.6l2.4-2.4c0.3,0.2,0.7,0.4,1.1,0.6c0.8,0.3,1.6,0.5,2.5,0.5h0.2c1,0,2-0.2,2.9-0.7  c0.9-0.5,1.7-1.2,2.2-2.1c0.6-0.9,0.9-1.9,0.9-2.9v-0.1C22.4,13.3,22.2,12.3,21.6,11.4L21.6,11.4z M18.7,16.4  c-0.7,0.7-1.4,1.2-2.3,1.2h-0.1c-0.5,0-1-0.1-1.4-0.4c-0.5-0.3-0.9-0.6-1.3-1.1c-0.3-0.5-0.5-1-0.5-1.5v-0.2c0-0.5,0.1-1,0.4-1.5  c0.3-0.5,0.7-0.9,1.2-1.3c0.5-0.3,1-0.5,1.6-0.5h0.1c0.5,0,1,0.1,1.5,0.3c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.5,1,0.5,1.5  c0,0.1,0,0.2,0,0.3C19.5,15.1,19.3,15.8,18.7,16.4L18.7,16.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspotIcon);
export default __webpack_public_path__ + "static/media/hubspot-icon.cd4e76adb96f3a4ee92fea231e5035ba.svg";
export { ForwardRef as ReactComponent };